import { DeliveryOrderInFlightScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <DeliveryOrderInFlightScreen />;
}
